'use strict';
var app = require('angular').module('dashboard');

app.controller('dashboardSheetsCtrl',  require('./dashboardSheetsCtrl'));
app.config(['$stateProvider', require('./dashboardSheetsConfig')]);

